export const COMPACT_NUMBER_OF_ROWS = 2;
export const COMPACT_VIDEOS_IN_ROW = 2;



// WEBPACK FOOTER //
// ./src/shared/constants/compact-layout.js